import { Reveal } from "@/components/MaskedLine";

const shots = [
  {
    src: "/images/chantier-bassin.png",
    caption: "Création de bassin & jardin d'inspiration japonaise",
    span: "md:col-span-7",
    clip: "clip-corner-tl",
  },
  {
    src: "/images/chantier-haie.png",
    caption: "Taille de haies en pleine intervention",
    span: "md:col-span-5",
    clip: "clip-corner-br",
  },
  {
    src: "/images/chantier-allee.png",
    caption: "Aménagement paysager : allée minérale & massifs",
    span: "md:col-span-5",
    clip: "clip-corner-br",
  },
  {
    src: "/images/chantier-gazon.png",
    caption: "Pelouse parfaite, pas japonais & bordures de galets",
    span: "md:col-span-7",
    clip: "clip-corner-tl",
  },
  {
    src: "/images/chantier-rouleaux.png",
    caption: "Pose de gazon en rouleaux — avant / après",
    span: "md:col-span-12",
    clip: "clip-corner-tl",
    wide: true,
  },
];

export const ClippedGallery = () => {
  return (
    <section id="realisations" data-testid="gallery-section" className="py-20 sm:py-28 lg:py-36 bg-[#121F17] relative rb-grain overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
          <div>
            <Reveal>
              <p className="font-mono-rb text-xs uppercase tracking-[0.25em] text-[#D4AF37] mb-6">Réalisations</p>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-rb text-3xl sm:text-4xl lg:text-5xl text-[#F5F3EE] leading-tight" data-testid="gallery-title">
                Le terrain, notre plus belle <span className="italic text-[#8CA893]">vitrine.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-[#F5F3EE]/60 text-sm max-w-xs leading-relaxed">
              Photos réelles de nos chantiers : taille, création, aménagement. Le résultat parle de lui-même.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 sm:gap-8">
          {shots.map((s, i) => (
            <Reveal key={i} delay={0.08 * i} className={s.span}>
              <figure
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden ${s.clip} cursor-pointer`}
              >
                <img
                  src={s.src}
                  alt={s.caption}
                  loading="lazy"
                  className={`w-full ${s.wide ? "h-[300px] sm:h-[420px]" : "h-[280px] sm:h-[360px]"} object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-110`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#121F17]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <span className="absolute top-4 left-4 font-mono-rb text-[10px] uppercase tracking-[0.2em] text-[#121F17] bg-[#D4AF37] rounded-full px-3 py-1.5">
                  Chantier réel
                </span>
                <figcaption className="absolute bottom-0 inset-x-0 p-6 translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-[opacity,transform] duration-500">
                  <span className="text-[#F5F3EE] font-serif-rb italic text-lg">{s.caption}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
